import React from 'react';
import { Row } from 'reactstrap';
import { WrapperField } from '../../../../../components/InputField/WrapperField';
import { observer } from 'mobx-react-lite';

const EntityV2 = ({
    asLabel,
    data,
    handleChange,
    hasError,
    index,
    cyclosFields,
    setErrors,
    isForEDD,
    isEditable = true,
}) => {
    const handleFieldError = (field, errorMsg) => {
        setErrors((prevErrors) => {
            const updatedErrors = { ...prevErrors };
            updatedErrors[field] = errorMsg;
            return updatedErrors;
        });
    };

    const canEdit = !asLabel && isEditable;
    const wrapperModeProps = { asDisplay: !canEdit, disabled: !canEdit };

    return (
        <div>
            <WrapperField
                {...wrapperModeProps}
                jsonField={cyclosFields["entities[].relations"]}
                arrayIndexing={index}
                dataObj={data}
                onChange={handleChange}
                showError={hasError}
                onError={(errorMsg) => handleFieldError(`entities[${index}].relations`, errorMsg)}
                isForEDD={isForEDD}
            />

            <Row>
                <WrapperField
                    className="col-sm-6"
                    {...wrapperModeProps}
                    jsonField={cyclosFields["entities[].name"]}
                    arrayIndexing={index}
                    dataObj={data}
                    onChange={handleChange}
                    showError={hasError}
                    onError={(errorMsg) => handleFieldError(`entities[${index}].name`, errorMsg)}
                    isForEDD={isForEDD}
                />

                <WrapperField
                    className="col-sm-6"
                    {...wrapperModeProps}
                    jsonField={cyclosFields["entities[].incorpCountry"]}
                    arrayIndexing={index}
                    dataObj={data}
                    onChange={handleChange}
                    showError={hasError}
                    onError={(errorMsg) => handleFieldError(`entities[${index}].incorpCountry`, errorMsg)}
                    isForEDD={isForEDD}
                />

                <WrapperField
                    className="col-sm-6"
                    {...wrapperModeProps}
                    jsonField={cyclosFields["entities[].website"]}
                    arrayIndexing={index}
                    dataObj={data}
                    onChange={handleChange}
                    showError={hasError}
                    onError={(errorMsg) => handleFieldError(`entities[${index}].website`, errorMsg)}
                    isForEDD={isForEDD}
                />

                <WrapperField
                    className="col-sm-6"
                    {...wrapperModeProps}
                    jsonField={cyclosFields["entities[].businessNature"]}
                    arrayIndexing={index}
                    dataObj={data}
                    onChange={handleChange}
                    showError={hasError}
                    onError={(errorMsg) => handleFieldError(`entities[${index}].businessNature`, errorMsg)}
                    isForEDD={isForEDD}
                />

                <WrapperField
                    className="col-sm-6"
                    {...wrapperModeProps}
                    jsonField={cyclosFields["entities[].yearOfIncorporation"]}
                    arrayIndexing={index}
                    dataObj={data}
                    onChange={handleChange}
                    showError={hasError}
                    onError={(errorMsg) => handleFieldError(`entities[${index}].yearOfIncorporation`, errorMsg)}
                    isForEDD={isForEDD}
                />

                <WrapperField
                    className="col-sm-6"
                    {...wrapperModeProps}
                    jsonField={cyclosFields["entities[].percentOwner"]}
                    arrayIndexing={index}
                    dataObj={data}
                    onChange={handleChange}
                    showError={hasError}
                    onError={(errorMsg) => handleFieldError(`entities[${index}].percentOwner`, errorMsg)}
                    isForEDD={isForEDD}
                />

                <WrapperField
                    {...wrapperModeProps}
                    jsonField={cyclosFields["entities[].sourceOfWealthList"]}
                    arrayIndexing={index}
                    dataObj={data}
                    onChange={handleChange}
                    showError={hasError}
                    onError={(errorMsg) => handleFieldError(`entities[${index}].sourceOfWealthList`, errorMsg)}
                    isForEDD={isForEDD}
                />
            </Row>
        </div>
    );
};

export default observer(EntityV2);
